import { z } from 'zod';

import { TranslationFnMap } from '~shared/i18n';

type ResetTokenErrorsKey = 'PASSWORD_REQUIRED' | 'PASSWORDS_MISMATCH';

type ResetTokenFormErrors = TranslationFnMap<ResetTokenErrorsKey>;

const resetTokenSchema = z
  .object({
    password: z.string().min(1, { error: 'PASSWORD_REQUIRED' }),
    password2: z.string().min(1, { error: 'PASSWORD_REQUIRED' }),
  })
  .refine((data) => data.password === data.password2, {
    error: 'PASSWORDS_MISMATCH',
    path: ['password2'],
  });

type ResetTokenFormData = z.infer<typeof resetTokenSchema>;

export { type ResetTokenFormData, type ResetTokenFormErrors, resetTokenSchema };
